










import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { quillEditor, Quill } from 'vue-quill-editor';
import { ImageExtend, QuillWatch } from './quill-image-extend-module';
import ImageResize from 'quill-image-resize-module';
import 'quill/dist/quill.snow.css';
Quill.register('modules/imageResize', ImageResize);
Quill.register('modules/ImageExtend', ImageExtend);
@Component({
    components: {
        quillEditor
    }
})
export default class QuillEditor extends Vue {
    @Prop({ default: '' })
    placeholder: string;
    @Prop({ default: '' })
    value: string;
    @Prop({ default: '' })
    action: string;
    @Prop({ default: false })
    disabled: Boolean;
    @Prop({ default: true })
    isComment: boolean;

    editorValue: string = '';
    editorOption: any;

    created() {
        this.editorOption = {
            modules: {
                toolbar: {
                    container: this.isComment
                        ? [['image']]
                        : [
                              ['bold', 'italic', 'underline', 'strike'],
                              [{ header: 1 }, { header: 2 }],
                              [{ list: 'ordered' }, { list: 'bullet' }],
                              [{ indent: '-1' }, { indent: '+1' }],
                              [{ color: [] }],
                              [{ align: [] }],
                              ['link', 'image']
                          ],
                    handlers: {
                        image: function () {
                            QuillWatch.emit(this.quill.id);
                        }
                    }
                },
                imageResize: {
                    displaySize: true
                },
                ImageExtend: {
                    loading: true,
                    name: 'file',
                    action: this.action,
                    response: res => {
                        let errMsg = '上传图片失败';
                        if (res.data) {
                            return res.data.url;
                        }
                        if (res.data && res.data.errorMsg) {
                            errMsg = res.data.errorMsg;
                        }
                        this.$mtd.message.error(errMsg);
                    }
                }
            },
            theme: 'snow',
            placeholder: this.placeholder
        };
    }

    mounted() {
        this.editorValue = this.value;
    }

    @Watch('value')
    onvValueChanged(val) {
        this.editorValue = val;
    }
    @Watch('editorValue')
    onvEditorValueChanged(val) {
        this.$emit('input', val);
    }
    clear() {
        this.editorValue = '';
    }
    blur() {
        (this.$refs.quillEditor as any).quill.blur();
    }
    enable(val) {
        (this.$refs.quillEditor as any).quill.enable(val);
    }
    handleFocus() {
        this.$emit('focus');
    }
    handleBlur() {
        this.$emit('blur');
    }
}
